import { Field, FieldProps } from "formik";

import MDBox from "../MDBox";
import MDInput from "../MDInput";
import MDTypography from "../MDTypography";

type FormFieldProps = React.ComponentProps<typeof Field> & {
  label: string;
  disableIcon?: boolean;
  externalLabel?: boolean;
};

const FormField: React.FC<FormFieldProps> = ({
  label,
  name,
  disableIcon = false,
  externalLabel = false,
  ...rest
}) => {
  return (
    <MDBox mb={1.5}>
      <Field name={name}>
        {({ field, meta }: FieldProps) => (
          <>
            {externalLabel && (
              <MDTypography variant="caption" color="text" sx={{ display: "block", mb: 0.5 }}>
                {label}
              </MDTypography>
            )}
            <MDInput
              {...field}
              {...rest}
              label={externalLabel ? undefined : label}
              fullWidth
              disabledIcon={disableIcon}
              error={!!(meta.touched && meta.error)}
              helperText={meta.touched && meta.error ? meta.error : undefined}
            />
          </>
        )}
      </Field>
    </MDBox>
  );
};

export default FormField;
